export default __webpack_public_path__ + "static/media/4.01cbeb83.png";